(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('commonWidgetsConverter', ["$q", "feature", function ($q, feature) {
        return function (input, args) {
            var deferred = $q.defer();
            var title = input.data.title;
            var rows = input.data.rows || [input.data.widgets];
            if (!_(args.commonWidgets).isUndefined()) {
                var commonWidgets = args.commonWidgets.data;
                _(rows).each(function (row) {
                    _(row).each(function (widget, idx) {
                        if (widget.type == 'reference') {
                            row[idx] = $.extend(true, {}, commonWidgets[widget.reference], widget, { type: commonWidgets[widget.reference].type });
                        }
                    });
                });
            }
            rows = _(rows).map(function (row) {
                return _(row).filter(function (widget) {
                    if (widget.noFeature && feature[widget.noFeature]) {
                        return false;
                    }
                    if (args.options && args.options.hideV1Only) {
                        return !widget.v1Only;
                    }
                    if (!args.options || !args.options.showV2Only) {
                        return !widget.v2Only;
                    }
                });
            });
            if (args.options) {
                _(rows).each(function (row) {
                    _(row).each(function (widget) {
                        if (widget.logic) {
                            if (widget.logic.name === 'policyInfoBoxes') {
                                if (args.options.infoboxesNoColor) {
                                    widget.logic.noColors = true;
                                }
                                if (args.options.infoboxesFontColor) {
                                    widget.logic.fontColors = true;
                                }
                                if (args.options.showV2Only && args.options.hideV1Only) {
                                    widget.logic.version = 'v2';
                                }
                            } else if (widget.logic.name === 'dashboardSecurityStackV2Logic') {
                                widget.logic.hideAnalyticsSecurityStack = args.options.hideAnalyticsSecurityStack;
                            }
                        }
                    });
                });
            }
            deferred.resolve($.extend({}, input, {
                data: {
                    title: title,
                    rows: rows
                }
            }));
            return deferred.promise;
        };
    }]);
}());